import { render, staticRenderFns } from "./OutOfStockIcon.vue?vue&type=template&id=8fa22632&scoped=true"
import script from "./OutOfStockIcon.vue?vue&type=script&lang=js"
export * from "./OutOfStockIcon.vue?vue&type=script&lang=js"
import style0 from "./OutOfStockIcon.vue?vue&type=style&index=0&id=8fa22632&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa22632",
  null
  
)

export default component.exports